import styled, { css } from 'styled-components';

const mixinSpanIconBlock = _ref => {
  let {
    block
  } = _ref;
  return block && css`
    display: block;
  `;
};
const mixinSpanSize = _ref2 => {
  let {
    size
  } = _ref2;
  return css`
  box-sizing: content-box !important;
  min-width: ${size}px;
  min-height: ${size}px;
  max-width: auto;
  max-height: ${size}px;
  width: ${size}px;
  height: ${size}px;
  & > svg {
    width: auto;
  }
`;
};
const mixinSpanColor = _ref3 => {
  let {
    color
  } = _ref3;
  return css`
  /* stylelint-disable-next-line */
  color: ${color};
`;
};
const mixinSpanTransform = _ref4 => {
  let {
    transform
  } = _ref4;
  return transform && css`
    & > svg {
      transform: translate(${transform.x ?? "0px"}, ${transform.y ?? "0px"});
    }
  `;
};
const SpanIcon = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__SpanIcon",
  componentId: "zettle__sc-1ibiyv0-0"
})(["", " ", " ", " ", " & > svg{vertical-align:top;}.svg-icon-paypal{display:none;}"], mixinSpanIconBlock, mixinSpanSize, mixinSpanColor, mixinSpanTransform);

export { SpanIcon };
//# sourceMappingURL=styles.js.map
